export default {"src":"/_next/static/media/shareholder_guide_2.ad130817.svg","height":222,"width":706,"blurWidth":0,"blurHeight":0};